import { useMemo } from 'react';
import { useCurrentUserProfile } from '~/hooks/useCurrentUserProfile';
import { toKpiRegionalCode } from '~/apis/analyticsApi';
import {
  buildPermissionSet,
  DASHBOARD_KEY_REGIONAL_PERMISSIONS,
  hasAnyPermission,
} from '~/lib/permissions';

export function useEffectiveRegionalCode(selectedRegionalCode: string) {
  const { data: profile } = useCurrentUserProfile();
  const permissionSet = useMemo(
    () => buildPermissionSet(profile?.permissions),
    [profile?.permissions]
  );
  const canPickRegion = hasAnyPermission(permissionSet, DASHBOARD_KEY_REGIONAL_PERMISSIONS);

  const effectiveRegionalCode = useMemo(() => {
    if (canPickRegion) {
      return toKpiRegionalCode(selectedRegionalCode);
    }
    return profile?.regional_code?.trim() || 'all';
  }, [canPickRegion, selectedRegionalCode, profile?.regional_code]);

  return { effectiveRegionalCode, canPickRegion, permissionSet };
}
